import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SiteService } from '@app/_services/site.service';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class FeatureGuard  {
    constructor(
        private router: Router,
        private siteService: SiteService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        let featureData = route.data.feature;
        return new Observable<boolean>(observer => {
            this.siteService.feature(featureData).subscribe(response => {
                if (response.code == 200) {
                    observer.next(true);
                    observer.complete();
                } else {
                    this.router.navigate(['/']);
                    observer.next(false);
                }
            }, err => {
                this.router.navigate(['/']);
                observer.next(false);
                observer.complete();
            })
        });
    }
}
